import "./StripeOnboardingRequiredPopup.css";

import React, { useState } from "react";
import { toast } from "react-toastify";

import { completeStripeConnectOnboarding } from "Config/API/action";

const StripeOnboardingRequiredPopup = ({ hide }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleCompleteSetup = async () => {
    if (submitting) return;
    const token = localStorage.getItem("token");
    if (!token) {
      toast("User session missing. Please login again.", { type: "error" });
      return;
    }

    setSubmitting(true);
    try {
      const appOrigin = window.location.origin;
      const refreshUrl = `${appOrigin}/refresh`;
      const returnUrl = `${appOrigin}/return`;
      const response = await completeStripeConnectOnboarding(
        token,
        refreshUrl,
        returnUrl
      );

      if (!response?.status || !response?.data?.onboarding_url) {
        throw new Error(
          response?.message || "Unable to create Stripe onboarding link."
        );
      }

      if (response?.data?.account_id) {
        sessionStorage.setItem("stripe_account_id", response.data.account_id);
        localStorage.setItem("stripe_account_id", response.data.account_id);
      }

      window.open(response.data.onboarding_url, "_blank");
      setSubmitting(false);
    } catch (err) {
      toast(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Unable to continue Stripe onboarding.",
        { type: "error" }
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="stripe-onboarding-popup-parent">
      <div className="stripe-onboarding-popup-body">
        <div className="stripe-onboarding-popup-close">
          <div onClick={() => hide(false)}>X</div>
        </div>
        <label className="stripe-onboarding-popup-heading">
          Complete Stripe Setup
        </label>
        <label className="stripe-onboarding-popup-description">
          Your Stripe onboarding is still pending. Please complete the Stripe
          setup first to continue with purchases and subscriptions.
        </label>
        <div className="stripe-onboarding-popup-actions">
          <button
            className="stripe-onboarding-popup-primary-btn"
            onClick={handleCompleteSetup}
            disabled={submitting}
          >
            {submitting ? "Please wait..." : "Complete Stripe Setup"}
          </button>
          <button
            className="stripe-onboarding-popup-secondary-btn"
            onClick={() => hide(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default StripeOnboardingRequiredPopup;
